import { User } from '../../models';
import request from './axiosClient';

const URL_LOGIN = '/login';
const URL_LOGOUT = '/logout';
const URL_TOKEN_ORDER = '/token-order';

export function loginAPI(data: User) {
  return request({
    url: URL_LOGIN,
    method: 'post',
    data: { ...data, role: 3 },
    noNeedToken: true,
  });
}

export function logoutAPI(token: string, params: {}) {
  return request({
    url: URL_LOGOUT,
    method: 'get',
    params,
    token,
  });
}

export function tokenOrderAPI(
  data: { bill_id: number; table_id: number; shop_id: number },
  params: { appName: string }
) {
  return request({
    url: URL_TOKEN_ORDER,
    method: 'post',
    params,
    data,
  });
}
